// extracted by mini-css-extract-plugin
export default {"experiences":"Experience_experiences__UGHFy"};